export default __webpack_public_path__ + "static/media/fondo_servicios.c01dc412.png";